import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

export function PageContainer({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn("mx-auto w-full max-w-7xl px-6 lg:px-10", className)}
      {...props}
    />
  );
}
